import { apiUrl } from "../constans";
import apiClient from '../libs/axios';
const leads = {
    namespaced: true,
    state: {
        leads: {
            data: [],
            current_page: 1,
            per_page: 1,
            total: 0
        },
    },

    mutations: {
        setLeads(state, leads) {
            let stat = state.leads;

            stat.data = leads.data
            stat.current_page = leads.current_page
            stat.per_page = leads.per_page
            stat.total = leads.total
        },
    },

    getters: {
        getLeads(state) {
            return state.leads
        },

    },

    actions: {
        getLeadsAction({ commit }) {
            // Simulación de una llamada asíncrona a la API de autenticación
            return new Promise((resolve, reject) => {

                apiClient.post(`${apiUrl}/v2/leads`)
                    .then(response => {
                        const leads = response.data;
                        console.log(leads)
                        commit('setLeads', leads.data);
                        resolve("Inicio de session exitoso");
                    })
                    .catch(error => {
                        console.error(error);
                        reject(error);
                    });
                // Verificación de las credenciales y obtención de los datos del usuario


            });

        },
    }
}

export default leads;
